import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const OpenChips = (selectedOptions,openOptions) => {
  
  return (
    <>
      {selectedOptions.map((option, index) => {
        const findoption = openOptions.find(value => value.value === option)
        const color = findoption?.color || "#333";
        const textColor = getContrastYIQ(color); // Helper function to ensure readable text
        
        return (
          <OverlayTrigger
            key={index}
            placement="top"
            overlay={<Tooltip id={`tooltip-${index}`}>{option}</Tooltip>}
          >
            <span 
              className="advTag ml-2 mb-2"
            //   style={{
            //     color: color,
            //     padding: "0.25rem 0.5rem",
            //     borderRadius: "0.42rem",
            //     fontSize: "10px",
            //     display: "inline-flex",
            //     alignItems: "center",
            //     height: "22px"
            //   }}
            >
             <span style={{color:color}} className="label label-pill label-inline label-sm  mr-1 font-weight-bold px-2"> {findoption?.shortLabel}</span>
            </span>
          </OverlayTrigger>
        );
      })}
      </>
  );
};

// Helper function to determine text color based on background
function getContrastYIQ(hexcolor) {
  hexcolor = hexcolor.replace("#", "");
  const r = parseInt(hexcolor.substr(0, 2), 16);
  const g = parseInt(hexcolor.substr(2, 2), 16);
  const b = parseInt(hexcolor.substr(4, 2), 16);
  const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
  return (yiq >= 128) ? "#000" : "#fff";
}

export default OpenChips;